export const ContentStates = ['Total', 'Approved', 'Translated', 'Needs Work']
export const ContentStateStyles = ['plain', 'primary', 'success', 'unsure']
